import React, { useEffect } from "react";

const Blog = () => {
  
  
  return (
    <div className="blog container">
      <h1 className="h1">Blog</h1>
    </div>
  );
};

export default Blog;
